import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import * as UserActions from '../../state/user.actions';
import { getToken } from '../../state/user.selectors';

export const authGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const auth = inject(AuthService);
  const store = inject(Store);

  return store.select(getToken).pipe(
    map((token) => {
      if (token === undefined || token === '' || auth.isTokenExpired(token)) {
        store.dispatch(UserActions.loginRedirect());
        return false;
      }
      return true;
    }),
    take(1)
  );
};
